const processSecEl = document.querySelector('.process-sec');

if (processSecEl) {
  const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            import('./gradient.component.js').then(({ Gradient }) => {
              const gradient = new Gradient();
              gradient.initGradient('#gradient-canvas-process');
            });

            obs.disconnect();
          }
        });
      },
      { threshold: 0.1 }
  );

  observer.observe(processSecEl);
}